module.exports = {"REMEMBEAR_MONTHLY":{"chargePrice":"6.00","regularPrice":"6.00"},"REMEMBEAR_YEARLY":{"chargePrice":"36.00","regularPrice":"36.00"},"REMEMBEAR_TWO_YEAR_PAYMENT":{"chargePrice":"60.00","regularPrice":"60.00"},"REMEMBEAR_THREE_YEAR_PAYMENT":{"chargePrice":"63.00","regularPrice":"63.00"}}


//////////////////
// WEBPACK FOOTER
// ./src/data/pricing.json
// module id = crmo
// module chunks = 26